import request from '@/utils/request'

let TdiagnosisApi = {

  /*舌诊列表*/
  list(data) {
    return request._post('/shop/plus.tdiagnosis.Index/index', data);
},
/*添加舌诊*/
add(data) {
    return request._post('/shop/plus.tdiagnosis.Index/add', data);
},
/*修改舌诊*/
edit(data) {
    return request._post('/shop/plus.tdiagnosis.Index/edit', data);
},
/*删除舌诊*/
del(data) {
    return request._post('/shop/plus.tdiagnosis.Index/del', data);
},
/*舌诊详情*/
detail(data) {
  return request._post('/shop/plus.tdiagnosis.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.tdiagnosis.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.tdiagnosis.Setting/getSetting', data, errorback);
    },
}
export default TdiagnosisApi;



// WEBPACK FOOTER //
// ./src/api/tdiagnosis.js